
















































































































import { Component, Vue, Watch } from 'vue-property-decorator'

import ApiIncoming from '@finx/web-repository/src/apis/Incoming/Incoming'
import Env from '@finx/web-repository/src/services/Env'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import { Apis as ApisWebRepository, Factories } from '@finx/web-repository'
import Apis from '@/Apis/_'
import NavBarStore from '@finx/web-repository/src/stores/NavBar'
import StatusStore from '@finx/web-repository/src/stores/Status'
import TheFooterStore from '@finx/web-repository/src/stores/TheFooter'
import AssinaturasStore from '@/store/Assinaturas'
import LogoutConfigStore from '@/store/LogoutConfigStore'
import _navBar from '@/components/NavBar/_'
// teste poc/acCamargo
import { signalRRemuneracaoBackofficeService } from '@/services/signalR-remuneracao-backoffice.service'
import AprovacaoApi from '@/Apis/Agendamento/Services/AprovacaoApi'
import routesAuthorized from '@/router/routes'

import _ from 'lodash'

// @ts-ignore
import Variables from '@/styles/variables.scss'

// EventBus
import EventBus from '@/plugins/EventBus'
import { isDarkTheme } from '@/utils/theme'
import { interceptorConfig } from '@finx/web-repository/src/apis/interceptor-config'
import { backofficeRoute } from '@/utils/common'
import { permissionService } from '@/services/permission.service'
import { getModule } from 'vuex-module-decorators'
import { Loading } from './types/_'

@Component
export default class CoreView extends Vue {
  timer: number
  compile: boolean = false
  isTokenExpired: boolean = true
  user: any = {}
  fab: boolean = false
  impersonationActive: boolean = false
  impersonationUser: any = null
  initialRouteResolved: boolean = false
  badge = {
    aprovacao: 0,
  }

  snack: any = {
    show: false,
    text: '',
    icon: '',
    color: '',
    timeout: 4500,
    multiLine: false,
    dismissible: false,
    acceptHTML: false,
  }

  loading: Loading = {
    status: false,
    text: '',
  }

  get snackbar() {
    return this.snack
  }

  set snackbar(value: any) {
    this.snack = value
  }

  get loadingRequest() {
    return this.loading
  }

  set loadingRequest(value: Loading) {
    this.loading = value
  }

  setGlobalLoadingRequest(status: boolean, text: string) {
    this.loadingRequest.status = status
    this.loadingRequest.text = text
  }

  clearGlobalLoadingRequest() {
    this.setGlobalLoadingRequest(false, '')
  }

  setLoadingRequest(status: boolean, text: string) {
    this.loadingRequest = { status, text }
  }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }

  onScroll(e) {
    if (typeof window === 'undefined') return
    const top = window.pageYOffset || e.target.scrollTop || 0
    this.fab = top > 400
  }

  backToTop() {
    this.$vuetify.goTo(0)
  }

  get logoutConfigStore() {
    return getModule(LogoutConfigStore, this.$store)
  }

  get assinatura() {
    return AssinaturasStore.getters.ASSINATURA
  }

  set assinatura(newValue) {
    AssinaturasStore.commit('ASSINATURA', newValue)
  }

  get hasAssinatura(): Boolean {
    return this.assinatura && Object.keys(this.assinatura).length > 0
  }

  get showNavBar() {
    return NavBarStore.getters.SHOW
  }

  get showStatus() {
    return StatusStore.getters.SHOW
  }

  get showTheFooter() {
    return TheFooterStore.getters.SHOW
  }

  get statusIsAtivo() {
    return StatusStore.getters.ATIVO
  }

  get backofficeArea() {
    return backofficeRoute()
  }

  get env() {
    const windowInfo = window as any
    return windowInfo.ENV
  }

  setGlobalSnackbar(snack) {
    this.snackbar = snack
  }

  resetLogoutTimer() {
    clearTimeout(this.timer)

    const timeoutMs = this.logoutConfigStore.logoutTimeoutMs
    this.timer = setTimeout(this.logout, timeoutMs)
  }

  async logout() {
    if (this.backofficeArea !== 'power-bi') {
      await this.logoutConfigStore.authLogout(this.$user.profile.sub)
    }
  }

  async applyLogoutConfiguration() {
    try {
      if (
        !this.logoutConfigStore.logoutConfig &&
        this.$user.profile.pageAuthorized.includes('agendamento')
      ) {
        const hospitaisResponse =
          await Apis.Agendamento.SolicitacaoCirurgiaApi.getHospitaisByUserCurrent()
        if (
          hospitaisResponse.success &&
          hospitaisResponse.data &&
          hospitaisResponse.data.length > 0
        ) {
          const [{ id: hospitalId }] = hospitaisResponse.data
          if (hospitalId) {
            await this.logoutConfigStore.getLogoutConfig(hospitalId)
          }
        }
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Erro ao carregar configuração de logout',
        icon: 'warning',
        color: '#C62828',
      })
    }
  }

  enableAutoLogout() {
    window.addEventListener('load', this.resetLogoutTimer)
    window.addEventListener('touchstart', this.resetLogoutTimer)
    window.addEventListener('keydown', this.resetLogoutTimer)
    window.addEventListener('keyup', this.resetLogoutTimer)
    window.addEventListener('focus', this.resetLogoutTimer)
    window.addEventListener('blur', this.resetLogoutTimer)
    window.addEventListener('click', this.resetLogoutTimer)
    window.addEventListener('visibilitychange', this.resetLogoutTimer)
  }

  async mounted() {
    this.checkImpersonation()
    Auth.initialize()
    await this.startApp()

    // Restore last visited path if user still authenticated
    try {
      const lastPath = localStorage.getItem('lastPath')
      if (lastPath && !this.isTokenExpired && this.user && this.user.profile) {
        this.$router.replace(lastPath)
        localStorage.removeItem('lastPath')
      }
    } catch (e) {
      // ignore localStorage errors
    }

    this.$router.onReady(async () => {
      const { isPublic } = this.$route.meta || {}
      if (this.user && !isPublic) {
        await this.applyLogoutConfiguration()
        this.enableAutoLogout()
      }
    })

    // eslint-disable-next-line
    console.log(
      `%c
███████╗██╗███╗   ██╗██╗  ██╗
██╔════╝██║████╗  ██║╚██╗██╔╝
█████╗  ██║██╔██╗ ██║ ╚███╔╝
██╔══╝  ██║██║╚██╗██║ ██╔██╗
██║     ██║██║ ╚████║██╔╝ ██╗
╚═╝     ╚═╝╚═╝  ╚═══╝╚═╝  ╚═╝

Integração e Transparência. Conectando os players da Saúde!

    `,
      'color: #00AEEF'
    )

    // Disable console if is production
    if (this.env === 'production') {
      this.disableConsole()
    }
  }

  async startApp() {
    await this.getUser()
    await this.checkAuthentication()
    await this.getBadgeValue()
    EventBus.$on('setSnackbar', (value) => this.setGlobalSnackbar(value))
    EventBus.$on('setLoadingRequest', (value) =>
      this.setGlobalLoadingRequest(value.status, value.text)
    )
    EventBus.$on('clearLoadingRequest', (value) =>
      this.clearGlobalLoadingRequest()
    )

    // Configure globally additional errors for web repository interceptor
    interceptorConfig.addAdditionalStatusCodeError(502, 503)

    // Configure globally additional interceptors by code error for web repository interceptor
    interceptorConfig.addInterceptorStatusCodeError(503, ((
      url: string,
      status: number,
      data: any,
      headers: any,
      response: any,
      nextFn: () => {}
    ) => {
      // When is 503 and has a body with attribute { "tempoPrevistoDeManutencao": 30 // Em minutos }
      // Need block alert and redirect to 503. So can't call nextFn
      try {
        if (response && response.tempoPrevistoDeManutencao) {
          if (this.$route.path !== '/503') {
            this.$router.push(
              `/503?retryAfter=${response.tempoPrevistoDeManutencao}`
            )
          }
        } else {
          nextFn()

          if (this.$route.path !== '/503') {
            this.$router.push('/503')
          }
        }
        // eslint-disable-next-line no-empty
      } catch (err) {}
    }) as any)

    // // teste poc/acCamargo
    // const userId = this.$user.profile.sub
    // signalRRemuneracaoBackofficeService.openConnection(userId)
  }

  checkImpersonation() {
    this.impersonationActive = sessionStorage.getItem('IMPERSONATION_ACTIVE') === 'true'
    try {
      const data = sessionStorage.getItem('IMPERSONATION_USER')
      this.impersonationUser = data ? JSON.parse(data) : null
    } catch (e) {
      this.impersonationUser = null
    }
    document.documentElement.classList.toggle('is-impersonating', this.impersonationActive)
  }

  async encerrarPersonificacao() {
    sessionStorage.removeItem('IMPERSONATION_ACTIVE')
    sessionStorage.removeItem('IMPERSONATION_USER')
    sessionStorage.removeItem('IMPERSONATION_ACTOR')
    sessionStorage.removeItem('IMPERSONATION_IN_PROGRESS')
    sessionStorage.removeItem('IMPERSONATION_REDIRECT')
    try {
      await Auth.userManager.removeUser()
    } catch (e) {
      // ignorar se falhar
    }
    Auth.login('/suporte/personificar')
  }

  async changeRoute(to, from) {
    const wasImpersonating = this.impersonationActive
    this.checkImpersonation()
    await this.redirect()
    // await this.getAssinatura()
    await this.compileMenu()

    const isFirstRoute = !this.initialRouteResolved
    const impersonationChanged = this.impersonationActive !== wasImpersonating

    if (isFirstRoute || impersonationChanged) {
      await this.getBadgeValue()
    }
    this.initialRouteResolved = true

    await this.compileView()
    await this.setUserId()
    // Persist last visited route for session/tab restore
    try {
      if (this.user && this.user.profile && to && to.fullPath) {
        localStorage.setItem('lastPath', to.fullPath)
      }
    } catch (e) {
      // ignore storage errors
    }
    await this.trackErrors(to, from)
  }

  async getUser() {
    if (this.$user && this.$user.profile) {
      localStorage.setItem('lastUser', this.$user.profile.email)
    }
  }

  async redirect() {
    const { redirectIfLogged, isPublic } = (this.$route.meta || {})

    if (this.isTokenExpired) {
      if (!isPublic) {
        await Auth.login('/')
      }
    } else {
      if (this.$route.path === '/' || this.$route.path === '/inicio') {
        const rotas = NavBarStore.getters.ROTAS

        if (rotas && rotas.length > 0) {
          this.$router.push(rotas[0].path)
          return
        }
      }

      if (redirectIfLogged && this.user && this.user.profile) {
        this.$router.push(redirectIfLogged)
      }
    }

    return false
  }

  async getBadgeValue() {
    if (permissionService.hasPermission('agendamento.backoffice.fluxoDeAprovacao.listar')) {
      const request = await AprovacaoApi.getBadgeValue()
      if (request && request.success) {
        this.badge.aprovacao = request.data.quantidade
      }
    }
  }

  async checkAuthentication() {
    const now = Math.floor(Date.now() / 1000)
    if (this.$user) this.isTokenExpired = Number(this.$user.expiresAt) < now
  }

  findRouteByKeyAuthorized(keyAuthorized: string) {
    const routeFound = routesAuthorized.find(
      (route) => route.meta && route.meta.keyAuthorized === keyAuthorized
    )
    return routeFound
  }

  redirectBackofficeDefaultRoute() {
    if (
      this.$user &&
      this.$user.profile &&
      this.$user.profile.pageAuthorized &&
      this.$user.profile.pageAuthorized.some((page: string) =>
        page.includes('backoffice-')
      )
    ) {
      let redirectRoute = {
        url: '',
        viewName: '',
        keyAuthorized: '',
      }
      if (
        this.$user.profile.defaultPage &&
        this.$user.profile.defaultPage.keyAuthorized.includes('backoffice-')
      ) {
        const routeFound = this.findRouteByKeyAuthorized(
          this.$user.profile.defaultPage.keyAuthorized
        )
        if (routeFound) {
          redirectRoute = {
            url: routeFound.path,
            viewName: routeFound.view,
            keyAuthorized: routeFound.meta.keyAuthorized || '',
          }
        }
      } else {
        const backofficeRoute = this.$user.profile.pageAuthorized.find(
          (page: string) => page.includes('backoffice-')
        )
        const routeFound = this.findRouteByKeyAuthorized(backofficeRoute)
        if (routeFound) {
          redirectRoute = {
            url: routeFound.path,
            viewName: routeFound.view,
            keyAuthorized: routeFound.meta.keyAuthorized || '',
          }
        }
      }
      return redirectRoute
    }
    return null
  }

  async compileMenu() {
    let { showMenu } = (this.$router as any).history.current.meta
    if (typeof showMenu === 'undefined') showMenu = true

    NavBarStore.commit('SHOW', showMenu)

    const roles: string[] = [
      'agendamento',
      'pilotoAgendamento',
      'remuneracaoMedicaPleno',
      'remuneracaoMedicaHospital',
      'extratoPagamento',
    ]
    let rolePerfil: string = ''

    if (this.$user !== null && this.$user.profile && this.$user.profile.roles) {
      if (Array.isArray(this.$user.profile.roles)) {
        this.$user.profile.roles.map((r) => {
          if (roles.some((c) => c === r)) {
            rolePerfil = r
          }
          return r
        })
      }
    }

    const rotas: any[] = []
    const isSecretariaBackoffice =
      this.$user &&
      this.$user.profile &&
      this.$user.profile.roles &&
      this.$user.profile.roles.some((role) =>
        [
          'secretariaDoAgendamentoBackoffice',
          'secretariaDoAmbulatorioBackoffice',
        ].includes(role)
      )

    _navBar.NavBar.map((c) => {
      if (isSecretariaBackoffice && c.keyAuthorized === 'backoffice') {
        const redirectRoute = this.redirectBackofficeDefaultRoute()
        rotas.push({
          ...c,
          ...(redirectRoute || {}),
        })
        return c
      }
      if (
        this.$user &&
        (c.isAuthorized ||
          (this.$user.profile.pageAuthorized &&
            this.$user.profile.pageAuthorized.includes(c.keyAuthorized)) ||
          permissionService.hasPermission(c.permissao))
      ) {
        rotas.push(c)
      }
      return c
    })

    if (
      this.$user &&
      this.$user.profile &&
      this.$user.profile.pageAuthorized &&
      this.$user.profile.pageAuthorized.includes('home')
    ) {
      rotas.length = 0
      _navBar.NavBarNew.map((c) => {
        if (
          this.$user &&
          (c.isAuthorized ||
            (this.$user.profile.pageAuthorized &&
              this.$user.profile.pageAuthorized.includes(c.keyAuthorized)))
        ) {
          rotas.push(c)
        }
        return c
      })
    }

    NavBarStore.commit('ROTAS', rotas)

    // this.loadRotas(rolePerfil)
    TheFooterStore.commit('SHOW', showMenu)
    this.compileStatus(showMenu)
  }

  loadRotas(role: string) {
    switch (role) {
      case 'agendamento':
        NavBarStore.commit('ROTAS', _navBar.NavBarMenuAgendamentoMedico)
        break

      case 'pilotoAgendamento':
        NavBarStore.commit('ROTAS', _navBar.NavBarAgendamentoMedico)
        break

      case 'remuneracaoMedicaPleno':
        NavBarStore.commit('ROTAS', _navBar.NavBarRemuneracaoMedicaPleno)
        break

      case 'remuneracaoMedicaHospital':
        NavBarStore.commit('ROTAS', _navBar.NavBarRemuneracaoMedicaHospital)
        break

      case 'extratoPagamento':
        NavBarStore.commit('ROTAS', _navBar.NavBarExtratoPagamento)
        break

      default:
        NavBarStore.commit('ROTAS', _navBar.NavBar)
        break
    }
  }

  async compileStatus(showMenu) {
    const status = StatusStore.getters.SHOW
    StatusStore.commit('ATIVO', false)

    if (status && showMenu) {
      StatusStore.commit('ATIVO', true)
    }
  }

  async compileView() {
    this.compile = true
  }

  async setUserId() {
    if (this.user && this.user.profile) {
      (Vue as any).$ga.set('userId', this.user.profile.email)
    }
  }

  async sendErrorAlert(to, from) {
    let userEmail = 'Não logado'

    if (this.user && this.user.profile) userEmail = this.user.profile.email

    const message = {
      title: 'Erro 404',
      text: `
      Erro na 404 na URL: ${to}
      Tela anterior: ${from}
      Usuário: ${userEmail}`,
      themeColor: Variables.clError,
    }

    ApiIncoming.Alert.sendAlert(message)
  }

  async setNavBarRoles(value) {
    return new Promise((resolve: any, reject: any) => {
      const roles = ['PLANO_CALCULADORA']

      NavBarStore.commit('ROLES', roles)

      resolve()
    })
  }

  async trackErrors(to, from) {
    if (to && from) {
      const pathTo = to.path
      let pathFrom = 'Acesso direto'

      if (from.name) pathFrom = from.path

      switch (to.name) {
        case 'not-found':
          this.sendErrorAlert(pathTo, pathFrom)
          break

        default:
          break
      }
    }
  }

  async getAssinatura(force?) {
    return new Promise(async (resolve: any, reject: any) => {
      if (!this.hasAssinatura && (this.user || force)) {
        const request = await ApisWebRepository.Plans.Assinatura.getAssinatura(true)
        const success = Factories.Apis.success(request)

        if (success) {
          AssinaturasStore.commit('ASSINATURA', request.data.value)
          if (this.hasAssinatura) {
            const assinaturaCalculadora: Boolean =
              AssinaturasStore.getters.ASSINATURA_PLANO_CALCULADORA

            if (assinaturaCalculadora) {
              await this.setNavBarRoles(true)
            }

            resolve()
          }
        } else { resolve() }
      } else {
        resolve()
      }
    })
  }

  @Watch('$route')
  async onRouteChanged(to, from) {
    await this.changeRoute(to, from)
  }

  disableConsole() {
    const consoleFallback = () => {}
    (window as any).console = {
      assert: consoleFallback,
      clear: consoleFallback,
      count: consoleFallback,
      countReset: consoleFallback,
      debug: consoleFallback,
      dir: consoleFallback,
      dirxml: consoleFallback,
      error: consoleFallback,
      group: consoleFallback,
      groupCollapsed: consoleFallback,
      groupEnd: consoleFallback,
      info: consoleFallback,
      log: consoleFallback,
      table: consoleFallback,
      time: consoleFallback,
      timeEnd: consoleFallback,
      timeLog: consoleFallback,
      timeStamp: consoleFallback,
      trace: consoleFallback,
      warn: consoleFallback,
    }
  }
}
